import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ARCHIVE_TASK_SAGA } from "../sagaTypes";
import { loaderAction, tasksCountAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getTasksSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/archive_task`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerArchiveTask(args) {
    const user = yield select(state => state.user);
    const tasks_count = yield select(state => state.tasks_count);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('task_id', args.data.task_id);
        formData.append('archive', args.data.archive);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Получаем обновлённый список задач
            yield put(getTasksSagaAction());
            // Добавляем количество текущих задач
            yield put(tasksCountAction(tasks_count + 1));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherArchiveTask() {
    yield takeLatest(ARCHIVE_TASK_SAGA, workerArchiveTask);
}